import { getAPI , postAPI, putAPI} from "../../api/api"
import {REACT_APP_TIMESHEET, REACT_APP_TIMESHEETPAYMENT } from "../../utils/common"

export async function timesheetDetails(timesheetId: string, projectId: string){
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-details/${timesheetId}?projectId=${projectId}`)
    return Details
}

export async function paymentDetailsApi(timesheetId: string, projectId: string){
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-payment-details/${timesheetId}?projectId=${projectId}`)
    return Details
}
export async function getCandidateLeaveDetails(pageNumber?: number, pageSize?: number, data?: any){
    const Details = postAPI( REACT_APP_TIMESHEET + `/listLeavesAndCompoff?size=${pageSize}&page=${pageNumber}`,data)
    return Details
}

export async function extractTimesheetDownload(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/timesheet-extract', body)
    return Details  
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-status-history/${timesheetId}`)
    return Details
}

export async function submitPaymentDetails(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/updateTimesheetOverallPayment', body)
    return Details
}
  
export async function updateTimeSheet(body: any){  
    const Details = putAPI( REACT_APP_TIMESHEET + '/candidate-timesheet', body)
    return Details
}

export async function approveTimeSheet(data: any){ 
    const Details = postAPI( REACT_APP_TIMESHEETPAYMENT + `/timesheet-approve`,data)
    return Details
}

export async function rejectTimeSheet(data: any){ 
    const Details = postAPI( REACT_APP_TIMESHEETPAYMENT + `/timesheet-reject`,data)
    return Details
}